var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTisco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.249 114.007C96.9173 114.007 93.3072 117.473 93.3072 121.95V132.058C93.3072 136.39 96.7729 140 101.249 140C105.582 140 109.192 136.534 109.192 132.058V121.95C109.192 117.617 105.582 114.007 101.249 114.007ZM103.415 132.202C103.415 133.502 102.405 134.513 101.105 134.513C99.8054 134.513 98.7946 133.502 98.939 132.202V122.094C98.939 120.794 99.9498 119.928 101.249 119.928C102.549 119.928 103.415 120.939 103.415 122.238V132.202Z",
    fill: "#0072BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1668 114.007C79.3004 114.007 78.4339 114.152 77.5675 114.44C75.5458 115.162 73.9574 116.606 72.9466 118.484C72.3689 119.495 72.0801 120.794 72.0801 121.949C72.0801 122.816 72.2245 123.682 72.5134 124.549L74.8238 131.48C74.9682 131.769 74.9682 131.913 74.9682 132.202C74.9682 132.491 74.8238 132.924 74.6794 133.213C74.3906 133.791 73.9574 134.079 73.3798 134.368C73.091 134.513 72.9466 134.513 72.6578 134.513C72.5134 134.513 72.3689 134.513 72.3689 134.513H72.0801V140.289H72.3689C72.5134 140.289 72.6578 140.289 72.8022 140.289C73.6686 140.289 74.535 140.144 75.4014 139.856C77.4231 139.134 79.0116 137.69 80.0224 135.812C80.6 134.801 80.8888 133.502 80.8888 132.347C80.8888 131.48 80.7444 130.614 80.4556 129.747L78.1451 122.816C78.0007 122.527 78.0007 122.383 78.0007 122.094C78.0007 121.805 78.1451 121.372 78.2895 121.083C78.5783 120.505 79.0115 120.217 79.5892 119.928C79.5892 119.639 79.878 119.639 80.1668 119.639C80.3112 119.639 80.3112 119.639 80.4556 119.639H80.7444V113.863H80.4556C80.4556 114.007 80.3112 114.007 80.1668 114.007Z",
    fill: "#0072BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4191 114.007C88.253 114.007 86.2314 114.874 84.7873 116.318C83.3433 117.762 82.4769 119.783 82.4769 121.95V132.058C82.4769 134.224 83.3433 136.246 84.7873 137.69C86.2314 139.134 88.1086 140 90.2747 140H90.4191C90.8523 140 91.2855 140 91.7188 139.856H92.0076V133.791L91.4299 134.08C91.1411 134.224 90.7079 134.368 90.2747 134.368C89.6971 134.368 89.1195 134.08 88.6863 133.646C88.253 133.213 88.1086 132.635 87.9642 132.058V121.95C87.9642 121.372 88.253 120.794 88.6863 120.361C89.1195 119.928 89.6971 119.639 90.2747 119.639C90.7079 119.639 91.1411 119.783 91.4299 119.928L91.8632 120.217V114.152H91.5743C91.2855 114.007 90.8523 114.007 90.4191 114.007Z",
    fill: "#0072BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.721 113.964L64.6349 139.957L70.2667 139.975L70.3527 113.982L64.721 113.964Z",
    fill: "#0072BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0069 119.495H54.4618V139.856H60.0935L60.2379 119.639H62.6928V113.863H52.0069V119.495Z",
    fill: "#0072BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0469 73.4296C60.0939 64.3321 58.9386 50.3249 65.87 40.0722C76.1227 33.2852 90.13 34.4404 99.083 43.5379C108.036 52.6354 109.191 66.6426 102.26 76.8953C97.9278 79.7834 92.7292 81.2274 87.6751 81.2274C87.6751 81.2274 87.6751 81.2274 87.5307 81.2274C80.8881 81.2274 74.2455 78.6282 69.0469 73.4296ZM38 61.7328V62.5993C38.1444 85.8484 56.917 104.621 80.1661 104.621C103.56 104.765 122.477 85.8484 122.621 62.4549C122.765 39.2058 103.993 20.1444 80.7437 20H80.3105C57.0614 20 38.2888 38.6282 38 61.7328Z",
    fill: "url(#paint0_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8198 28.3755C81.0328 28.3755 74.3902 30.9748 69.1917 36.0289C67.892 37.3286 66.7368 38.7726 65.8704 40.2166C76.1231 33.4296 90.1303 34.5849 99.0834 43.6823C108.036 52.7798 109.192 66.787 102.26 77.0398C103.704 76.0289 105.148 75.0181 106.448 73.7185C116.845 63.4657 116.845 46.7148 106.592 36.3177C101.394 30.9748 94.6068 28.3755 87.8198 28.3755Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.438 33.4254) scale(81.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2134,
    stopColor: "#2AA3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#2898D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6119,
    stopColor: "#2585C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#206AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    stopColor: "#1A488A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 106.582,
    y1: 36.2275,
    x2: 84.0652,
    y2: 58.5888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#881A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117766,
    stopColor: "#8D1B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1023,
    stopColor: "#AE1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1953,
    stopColor: "#C82225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2908,
    stopColor: "#DA2428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3903,
    stopColor: "#E52629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.6209,
    height: 120,
    fill: "white",
    transform: "translate(38 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTisco);
export default __webpack_public_path__ + "static/media/tisco.0b2349d4.svg";
export { ForwardRef as ReactComponent };